import React from 'react';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Typography } from '@material-ui/core';
import { Close } from '@material-ui/icons';
import PropTypes from 'prop-types';

const DeleteModal = ({
  open,
  numberOfSelectedRows,
  onClose,
  onDelete,
}) => (
  <Dialog
    open={open}
    fullWidth
  >
    <DialogTitle>Delete Promo Codes</DialogTitle>
    <Box position="absolute" top={0} right={0}>
      <IconButton onClick={onClose}>
        <Close />
      </IconButton>
    </Box>
    <DialogContent>
      <Typography>
        {numberOfSelectedRows}
        {' '}
        Promo codes will be deleted. This action cannot be undone
      </Typography>
    </DialogContent>
    <DialogActions>
      <Button color="white" variant="contained" onClick={onClose}>
        Cancel
      </Button>
      <Button color="secondary" variant="contained" onClick={onDelete}>
        Delete
      </Button>
    </DialogActions>
  </Dialog>
);

DeleteModal.propTypes = {
  open:                 PropTypes.bool.isRequired,
  numberOfSelectedRows: PropTypes.number.isRequired,
  onClose:              PropTypes.func.isRequired,
  onDelete:             PropTypes.func.isRequired,
};

export default DeleteModal;
